import { xhr } from '@/api/config/Repository'
import PenaltyGridResponse from '@/services/penaltyGrid/models/PenaltyGridResponse'
import PenaltyGridResponseDTO from '../../penaltyGrid/dto/PenaltyGridResponseDTO'
import PenaltyGridRepository from '../PenaltyGridRepository'
import PenaltyGridTableRequest from '@/services/penaltyGrid/models/PenaltyGridTableRequest'
export default class PenaltyGridRepositoryImpl implements PenaltyGridRepository {
  async getTableData (params: any, req: PenaltyGridTableRequest): Promise<PenaltyGridResponse> {
    const endpoint = `penaltygrid/getPenalty?countryId=${params.countryID}&pageNumber=${req.pageNumber}&pageSize=${req.pageSize}&sortBy=${req.sortBy}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<PenaltyGridResponseDTO>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data.data,
      totalCount: response.data.totalCount
    }
  }

  async modifyPenaltyGrid (entityUrl: string, request: PenaltyGridTableRequest): Promise<PenaltyGridResponse> {
    const endpoint = `/${entityUrl}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<any, any>(endpoint, request, { headers })
    return response.data
  }
}
